import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { ReactTyped } from 'react-typed';

export default function UserContent() {
  const [showSection, setShowSection] = useState(false);
  const [numberOfUsers, setNumberOfUsers] = useState(0);
  const [users, setUsers] = useState([]);
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showOption1, setShowOption1] = useState(false);
  const [showOption2, setShowOption2] = useState(false);
  const [userNameValues, setUserNameValues] = useState([]);
  const [amountOption1, setAmountOption1] = useState("");
  const [percentageOption1, setPercentageOption1] = useState("");
  const [priceOption1, setPriceOption1] = useState("");
  const [amountsOption1, setAmountsOption1] = useState([]);
  const [amountEntered, setAmountEntered] = useState("");
  const [theanswer, settheanswer] = useState(false);

  const handleRadioChange = (e) => {
    setShowSection(e.target.value === "yes");
  };

  const handleNumberOfUsersChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setNumberOfUsers(value);
    }
  };

  const handleAddButtonClick = () => {
    const newUsers = [];
    const newUserNameValues = [];
    for (let i = 0; i < numberOfUsers; i++) {
      newUsers.push({ userName: "", percent: "", price: "" });
      newUserNameValues.push("");
    }
    setUsers(newUsers);
    setUserNameValues(newUserNameValues);
  };

  const handlePercentChange = (index, value) => {
    const newUsers = [...users];
    newUsers[index].percent = value;
    setUsers(newUsers);

    const total = newUsers.reduce(
      (acc, user) => acc + parseFloat(user.percent || 0),
      0
    );
    setTotalPercentage(total);
  };

  const handleUserNameValueChange = (index, value) => {
    const newUserNameValues = [...userNameValues];
    newUserNameValues[index] = value;
    setUserNameValues(newUserNameValues);
  };

  const handleDropdownOptionClick = (option) => {
    if (option === "Option 1") {
      setShowOption1(true);
      setShowOption2(false);
    } else if (option === "Option 2") {
      setShowOption1(false);
      setShowOption2(false);
    }
  };

  const handleAmountOption1Change = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setAmountOption1(value);
      calculatePriceOption1(value, percentageOption1);
    }
  };

  const handlePercentageOption1Change = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setPercentageOption1(value);
      calculatePriceOption1(amountOption1, value);
    }
  };

  const handleAmountEnteredChange = (e) => {
    const value = e.target.value;
    setAmountEntered(value);
  };

  const calculatePriceOption1 = (amount, percentage) => {
    const price = amount - (percentage / 100) * amount;
    setPriceOption1(price.toFixed(2)); // Rounded to 2 decimal places
    const newAmountsOption1 = userNameValues.map((_, index) => {
      return ((users[index].percent / 100) * price).toFixed(2);
    });
    setAmountsOption1(newAmountsOption1);
  };

  useEffect(() => {
    const newAmountsOption1 = new Array(numberOfUsers).fill("");
    setAmountsOption1(newAmountsOption1);
  }, [numberOfUsers]);

  const isSubmitButtonVisible = () => {
    return (
      totalPercentage === 100 && users.every((user) => user.percent !== "")
    );
  };

  const onlyNumbers = (value) => {
    return /^\d*$/.test(value);
  };

  const handleSubmit = () => {
    setShowDropdown(true);
    settheanswer(true);
  };

  return (
    <div>
      <div className="fw-semibold text-center font_size_loan_investment_one hieght_fixed">
        <ReactTyped
          strings={['Percentage Distribution Calculator']}
          typeSpeed={30}
          loop={false}
          showCursor={false}
        />
      </div>
      <div className="container d-flex justify-content-between witdh_investment_one_mediaquery main_div">
        <div>Investment</div>
        <div className="d-flex">
          <input
            className="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault1"
            value="yes"
            onChange={handleRadioChange}
          />
          <div className="ms-3">Yes</div>
        </div>
        <div className="d-flex">
          <input
            className="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="flexRadioDefault2"
            value="no"
            onChange={handleRadioChange}
          />
          <div className="ms-3">No</div>
        </div>
      </div>

      {showSection && (
        <div className="section_one maring_stuf container">
          <Card className="card_main">
            <Card.Body>
           
              <div className="label_1_user text-start">
                <div className="fs-5 mb-3 ms-1">Desired Number of Users</div>
                <div className="d-flex justify-content-between">
                  <div className="input-group w-75 input_Box">
                    <input
                      type="text"
                      placeholder="Enter the Number"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      value={numberOfUsers}
                      onChange={handleNumberOfUsersChange}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn_primary drop_button_small Add_button"
                    onClick={handleAddButtonClick}
                  >
                    Add
                  </button>
                </div>
              </div>
              {users.map((user, index) => (
                <div
                  key={index}
                  className="label_1_user text-start mt-3 d-flex justify-content-between"
                >
                  <div className="text-start">
                    <div className="fs-5 mb-3 ms-1">User-Name</div>
                    <div className="input-group w-100 user_name_value input_Box">
                      <input
                        type="text"
                        placeholder="Enter the User Name"
                        aria-label="Recipient's username"
                        aria-describedby="basic-addon2"
                        value={user.userName}
                        onChange={(e) => {
                          const newUsers = [...users];
                          newUsers[index].userName = e.target.value;
                          setUsers(newUsers);
                          handleUserNameValueChange(index, e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="fs-5 mb-3 ms-1">Percent</div>
                    <div className="input-group w-100 input_Box">
                      <input
                        type="text"
                        className="percentage_input"
                        placeholder="Enter the Percent"
                        aria-label="Percent"
                        aria-describedby="basic-addon2"
                        value={user.percent}
                        onChange={(e) =>
                          onlyNumbers(e.target.value) &&
                          handlePercentChange(index, e.target.value)
                        }
                      />
                      <span className="input-group-text btn_primary drop_button_small">%</span>
                    </div>
                  </div>
                </div>
              ))}
              <div className="mt-3 container text-center">
                <div>
                  {totalPercentage !== 0 && (
                    <div
                      style={{
                        color: totalPercentage === 100 ? "green" : "orange",
                      }}
                    >
                      Total Percentage: {totalPercentage}%
                    </div>
                  )}
                </div>
                <div className="mt-3">
                  {isSubmitButtonVisible() && (
                    <button
                      type="button"
                      className="btn button_years_months "
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
      )}
      {/* Option 1 */}
      <div
        className="option_1_Example_4 maring_stuf container"
        style={{ display: theanswer ? "block" : "none" }}
      >
        <Card className="card_main">
          <Card.Body>
            <div className="option_1_example1 maring_stuff container">
              <div className="d-flex justify-content-between">
                <div className="label_1_user text-start col-md-4 me-2">
                  <div className="font_wdth_enter_amount mb-3 ms-1">Enter Amount</div>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control Amount_enterd_option_1"
                      placeholder="Enter the Number"
                      aria-label="Recipient's username"
                      value={amountOption1}
                      onChange={handleAmountOption1Change}
                    />
                  </div>
                </div>
                <div className="text-start col-md-3">
                  <div className="font_wdth_enter_amount mb-3 ms-1">Percentage</div>
                  <div className="input-group mb-3 percetage_option_1_input">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Recipient's username"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      value={percentageOption1}
                      onChange={handlePercentageOption1Change}
                    />
                    <span className="input-group-text btn_primary drop_button_small" id="basic-addon2">
                      %
                    </span>
                  </div>
                </div>
                <div className="text-start col-md-4">
                  <div className="font_wdth_enter_amount mb-3 ms-1">Price</div>
                  <div className="input-group mb-3 w-75">
                    <span className="input-group-text btn_primary drop_button_small" id="basic-addon2">
                      $
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Recipient's username"
                      aria-label="Recipient's username"
                      aria-describedby="basic-addon2"
                      value={priceOption1}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                {userNameValues.map((name, index) => (
                  <div
                    className="input-group mb-3 User_amount_option_1_answer"
                    key={index}
                  >
                    <div className="text-start ms-2">
                      <div className="fs-5 mb-3 ms-1">{name}</div>
                      <input
                        type="text"
                        className="form-control display_amout_option_1"
                        placeholder="User Amount"
                        value={amountsOption1[index]}
                        readOnly
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
